
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('clients.new')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="clientForm" class="px-3">
            <div class="black--text">
              {{ $t('clients.main_data_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col cols="12" sm="12" md="5">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('clients.full_name_form_label')"
                  v-model="new_client.name"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-radio-group v-model="new_client.document_kind" row dense mandatory class="mt-n2">
                  <v-radio :label="$t('clients.cpf_form_label')" value="cpf"></v-radio>
                  <v-radio :label="$t('clients.cnpj_form_label')" value="cnpj"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col v-if="new_client.document_kind == 'cpf'" cols="12" sm="8" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('clients.cpf_form_label')"
                  v-model="new_client.document"
                  :rules="cpf"
                  v-mask='"###.###.###-##"'
                ></v-text-field>
              </v-col>
              <v-col v-if="new_client.document_kind == 'cnpj'" cols="12" sm="8" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('clients.cnpj_form_label')"
                  v-model="new_client.document"
                  :rules="cnpj"
                  v-mask='"##.###.###/####-##"'
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align='center' class="mt-3">
              <v-col cols="12" sm="6" md="4" v-if="new_client.document_kind == 'cpf'">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('clients.rg_form_label')"
                  v-model="new_client.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('clients.phone_form_label')"
                  v-model="new_client.phone"
                  :rules="required"
                  v-mask='((new_client.phone && new_client.phone.length) < 15) ? "(##) ####-####" : "(##) # ####-####"'
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('clients.email_form_label')"
                  v-model="new_client.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="black--text my-3">
              {{ $t('clients.address_form_label') }}
            </div>

            <address-form ref="address_form" :validate_form="true" :address="new_client.address"></address-form>
          </v-form>
        </template>


        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelClient" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveClient" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="loading" loadingText="saving" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import AddressForm from '../shared/forms/AddressForm.vue';

export default {
  name: 'DialogCreateClient',
  mixins: [ validations ],
  components: {
    AddressForm
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      loading: false,
      
      new_client: {
        name: null,
        second_name: null,
        document: null,
        document_kind: null,
        status: 'active',
        // json_attributes
        phone: null,
        rg: null,
        email: null,

        address: {
          street: null,
          number: null,
          district: null,
          city: null,
          state: null,
          zip: null,
          complement: null,
        },

        company_ids: [],
      }
    }
  },
  methods: {
    cancelClient(){
      this.dialog=false
    },
    saveClient(){
      if (this.$refs.clientForm.validate()){
        this.loading = true
        Api.Client.create(this.new_client).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>